import React, { useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import websitelogo from '../../../../assets/logos/websitelogo.svg';

import ContactSupportIcon from '@mui/icons-material/ContactSupport';

import CallIcon from '@mui/icons-material/Call';

import ChatIcon from '@mui/icons-material/Chat';

import {
	Alert,
	Box,
	CssBaseline,
	Grid,
	InputAdornment,
	OutlinedInput,
	Snackbar,
	Typography,
} from '@mui/material';

import Paper from '@mui/material/Paper';

import { forgotPassword } from '../../../services/api/apiManager';

import Button from '@mui/material/Button';

import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';

import { useNavigate, Link } from 'react-router-dom';

function ForgotPassword() {
	const defaultTheme = createTheme();
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [error, setError] = useState(null);
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarOpenError, setSnackbarOpenError] = useState(false);
	const [snackbarOpenSuccess, setSnackbarOpenSuccess] = useState(false);

	const handleSendPasscodeClick = async () => {
		try {
			if (!email.trim()) {
				// If email is empty or contains only whitespace
				setSnackbarOpen(true);
				return;
			}
			debugger;

			const formData = new FormData();
			formData.append('email', email);
			const data = { email: email };
			// Call the forgotPassword function with the formData
			const res = await forgotPassword(data);
			if (res && res?.status === 200) {
				setSnackbarOpenSuccess(true);

				setTimeout(() => {
					navigate('/');
				}, 1500);
			} else {
				setSnackbarOpenError(true);
			}
			// Handle the success response
		} catch (error) {
			// Handle errors from the API call
			setError('Error occurred while resetting password. Please try again.');
		}
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '40px 10px',
					'@media (max-width: 600px)': {
						// Styles for xs and sm screens
						padding: '70px 30px',
					},
					'@media (max-width: 1200px)': {
						// Styles for xs and sm screens
						padding: '30px 30px',
					},
				}}
			>
				<CssBaseline />
				<Grid
					container
					item
					xl={10}
					lg={10}
					md={12}
					sm={10}
					xs={12}
					justifyContent="center"
				>
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={4.5}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/singupbacground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							backgroundSize: 'cover',
							display: 'flex',
							flexDirection: 'column',
							borderRadius: '15px 0px 0px 15px',
							justifyContent: 'space-between',
							// background: '#197CCC',
							display: { sm: 'none', xs: 'none', md: 'flex', xl: 'flex' },
						}}
					>
						<Grid
							item
							sx={{
								display: 'flex',
								flex: '1',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<Typography
								variant="h5"
								sx={{
									fontFamily: 'Poppins',
									color: 'white',
									fontSize: '23px',
									fontWeight: '600',
									textAlign: 'center',
								}}
							>
								RESET PASSWORD EFFORTLESSLY
							</Typography>
							<Typography
								variant="h5"
								sx={{
									fontFamily: 'Poppins',
									color: 'white',
									fontSize: '18px',
									textAlign: 'center',
									fontWeight: '400',
								}}
							>
								Your Express Gateway to Swift <br /> Password Recovery !
							</Typography>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'space-evenly',
								borderTop: '0.5px solid rgba(255, 255, 255, 0.40)',
								padding: '15px 50px',
							}}
						>
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ContactSupportIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/aboutUs'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											About Us
										</Typography>
									</Link>
								</Grid>
							</Grid>

							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<CallIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/contactUs'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Contact Us
										</Typography>
									</Link>
								</Grid>
							</Grid>
							{/* <Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ChatIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/feedback'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Feedback
										</Typography>
									</Link>
								</Grid>
							</Grid> */}
						</Grid>
					</Grid>
					<Grid
						component={Paper}
						elevation={6}
						square
						item
						xs={12}
						sm={8}
						md={5}
						lg={4.5}
						xl={3.5}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							borderRadius: '0px 15px 15px 0px',
							'@media (max-width: 600px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
							},
							'@media (max-width: 900px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
								justifyContent: 'center',
							},
						}}
					>
						<Box
							sx={{
								marginLeft: '30px',
								margin: ' 30px 20px',
								display: 'flex',
								flexDirection: 'column',
								// alignItems: 'center',
								// justifyContent: 'center',
								'@media (max-width: 800px)': {
									// Styles for xs and sm screens
									margin: '15px',
								},
							}}
						>
							<img
								src={websitelogo}
								alt="Your Alt Text"
								style={{
									maxWidth: '200px',
									height: 'auto',
									objectFit: 'contain',
								}}
							/>
							<Typography
								component="h1"
								variant="h4"
								sx={{
									alignSelf: 'start',
									fontSize: '23px',
									fontFamily: 'Poppins',
									fontWeight: '600',
									marginTop: '20px',
								}}
							>
								Enter your Email!
							</Typography>
							<Box
								// component="form"
								noValidate
								sx={{
									mt: 1,
								}}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#7E7D7D',
										fontSize: '17px',
										fontFamily: 'Poppins',
									}}
								>
									Enter your email and we&apos;ll send you a New Password.
								</Typography>

								<OutlinedInput
									margin="normal"
									fullWidth
									type="email"
									name="email"
									autoComplete="email"
									size="small"
									autoFocus
									required
									id="email"
									onChange={(e) => setEmail(e.target.value)}
									endAdornment={
										<InputAdornment position="end">
											<MailOutlineOutlinedIcon color="action" />
										</InputAdornment>
									}
									sx={{
										marginBottom: '50px',
										marginTop: '15px',
										fontSize: '20px',
									}}
								/>

								<Button
									variant="filled"
									fullWidth
									sx={{
										background: '#e87511',
										color: 'white',
										borderRadius: '6px',
										height: '40px',
										width: '100%',
										fontSize: '20px',
										fontFamily: 'Poppins',
										fontWeight: '400',
										marginTop: '25px',
										border: ' 2px solid #E87511',
										'&:hover': {
											borderColor: '#e87511',
											color: '#e87511',
										},
										'@media (max-width: 600px)': {
											// Styles for xs and sm screens
											fontSize: '15px',
										},
									}}
									onClick={handleSendPasscodeClick}
								>
									SEND PASSCODE
								</Button>
								<Link to={'/'}>
									<Typography
										variant="body1"
										sx={{
											fontFamily: 'Poppins',
											// color: 'black',
											display: 'flex',
											justifyContent: 'flex-end',
										}}
									>
										{'Login >'}
									</Typography>
								</Link>
							</Box>
						</Box>
					</Grid>
				</Grid>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={snackbarOpen}
					autoHideDuration={2000}
					onClose={() => setSnackbarOpen(false)}
					message="Please enter your email."
					action={
						<React.Fragment>
							<Button
								sx={{ color: 'white' }}
								size="small"
								onClick={() => setSnackbarOpen(false)}
							>
								CLOSE
							</Button>
						</React.Fragment>
					}
					ContentProps={{
						sx: {
							backgroundColor: 'red',
							color: 'white',
							fontFamily: 'Poppins',
						},
					}}
				/>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={snackbarOpenError}
					autoHideDuration={2000}
					onClose={() => setSnackbarOpenError(false)}
					message="Email not Registered. Please enter valid Email "
					action={
						<React.Fragment>
							<Button
								sx={{ color: 'white' }}
								size="small"
								onClick={() => setSnackbarOpen(false)}
							>
								CLOSE
							</Button>
						</React.Fragment>
					}
					ContentProps={{
						sx: {
							backgroundColor: 'red',
							color: 'white',
							fontFamily: 'Poppins',
						},
					}}
				/>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={snackbarOpenSuccess}
					autoHideDuration={1500}
					onClose={() => setSnackbarOpenSuccess(false)}
					message="New Password Sent Check Your email"
					action={
						<React.Fragment>
							<Button
								sx={{ color: 'white' }}
								size="small"
								onClick={() => setSnackbarOpenSuccess(false)}
							>
								CLOSE
							</Button>
						</React.Fragment>
					}
					ContentProps={{
						sx: {
							backgroundColor: '#3EAE4D',
							color: 'white',
							fontFamily: 'Poppins',
							fontWeight: '300',
						},
					}}
				/>
			</Grid>
		</ThemeProvider>
	);
}
export default ForgotPassword;
